// extracted by mini-css-extract-plugin
module.exports = {"container":"Divider_container__1g7Dg","title":"Divider_title__1sooG","horizontalLine":"Divider_horizontalLine__3q8tv","count":"Divider_count__CZwjL"};